export let saferoom = [
    {
        "name": "Beach",
        // "image":
        "link":"/beach",
        "audio":"./../../assets/Audios/beachbg.mp3",
    },
    {
        "name": "Forest",
        // "image":
        "link":"/forest",
        "audio":"./../../assets/Audios/saferoombg.mp3",
    },
    {
        "name": "Calm Room",
        // "image":
        "link":"/house",
        "audio":"./../../assets/Audios/saferoombg.mp3",
    },
    {
        "name": "Mall",
        // "image":
        "link":"/mall",
        "audio":"./../../assets/Audios/saferoombg.mp3",
    },
]